var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M0.825195 7.16887V10.7951C0.825195 11.0973 1.00651 11.7017 1.73176 11.7017C2.45701 11.7017 7.67479 11.7017 10.193 11.7017C10.4952 11.7017 11.0996 11.5204 11.0996 10.7951C11.0996 10.0699 11.0996 8.27689 11.0996 7.47106V7.16887M5.96239 8.07544V1.72949M5.96239 1.72949L3.2427 4.14699M5.96239 1.72949L8.68208 4.14699",
    stroke: "black",
    strokeWidth: 1.20875
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadTwitter);
export default __webpack_public_path__ + "static/media/download_twitter.edbb8558806cac239328d39188c8c534.svg";
export { ForwardRef as ReactComponent };